export enum EvoAIModels {
  AWS_CLAUDE_SONNET_V3_5 = 'AWS_CLAUDE_SONNET_V3',
  AWS_CLAUDE_HAIKU_V3 = 'AWS_CLAUDE_HAIKU_V3',
  MARITAKA_AI_SABIA_3 = 'MARITAKA_AI_SABIA_3',
}
